import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectCourses, selectTotal, selectPage, selectLimit } from '../selectors/courses.selector';
import { coursesActions } from '../actions/courses.actions';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class CoursesFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly courses$ = this.store.select(selectCourses);
    readonly total$ = this.store.select(selectTotal);
    readonly page$ = this.store.select(selectPage);
    readonly limit$ = this.store.select(selectLimit);

    readonly courses = this.store.selectSignal(selectCourses);
    readonly total = this.store.selectSignal(selectTotal);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly page = this.store.selectSignal(selectPage);
    readonly limit = this.store.selectSignal(selectLimit);

    getCourses(value: PaginationParams): void {
        this.store.dispatch(coursesActions.getCourses({ value }));
    }

    clear(): void {
        this.store.dispatch(coursesActions.clear());
    }
}
